import { gql } from 'graphql-request';

import {
  TeamContractorBlocked,
  TeamContractorFullName,
  TeamContractorID,
  TeamContractorImageFile,
  TeamID,
  TeamName,
  TeamNanoID,
  TeamUserBlocked,
  TeamUserFullName,
  TeamUserID,
  TeamUserImageFile,
  TeamUUID
} from '../teamsTypes';

export interface FetchTeamUsersAndContractorsQueryResponse {
  id: TeamID;
  uuid: TeamUUID;
  nanoId: TeamNanoID;
  name: TeamName;
  users: {
    id: TeamUserID;
    fullName: TeamUserFullName;
    blocked: TeamUserBlocked;
    image?: {
      file: TeamUserImageFile;
    };
  }[];
  contractors: {
    id: TeamContractorID;
    fullName: TeamContractorFullName;
    blocked: TeamContractorBlocked;
    image?: {
      file: TeamContractorImageFile;
    };
  }[];
}

export const FETCH_TEAM_USERS_AND_CONTRACTORS_QUERY = gql`
  query TeamUsersAndContractors($uuid: ID!) {
    team(uuid: $uuid) {
      id
      uuid
      nanoId
      name
      users {
        id
        fullName
        blocked
        image {
          file
        }
      }
      contractors {
        id
        fullName
        blocked
        image {
          file
        }
      }
    }
  }
`;
